import { ChangeDetectorRef, Component, HostListener, Input, ViewChild } from '@angular/core';
import { BusinessSolutionsService } from 'src/app/services/business-solutions/business-solutions.service';
import { getLanguageCookie } from 'src/assets/language';
import { Subscription } from 'rxjs';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';
import { localStorageToJsonAsync} from "../../helpers/cookieToJson";
import { addAlert, apiOfflineAsync } from "../../layouts/pages/pages.component";
import { TreeNode } from 'primeng/api';
import { parse, stringify } from "circular-json";
import { asyncForEach } from "../../helpers/asyncForEach";
import { v4 } from 'uuid';
import { TooltipPosition } from '@angular/material/tooltip';
import { FormControl } from '@angular/forms';
import { ClipboardService } from 'src/app/services/clipboard/clipboard.service';
import { to64decode, to64DecodeSafe } from 'src/app/helpers/base64';
import { UsersService } from 'src/app/services/users/users.service';
import { FunctionService } from 'src/app/services/function.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { ExtendedAttributeService } from 'src/app/services/extended_attribute/extended-attribute.service';
import { Router } from '@angular/router';
import { MatMenu } from '@angular/material/menu';
import { CorporationService } from 'src/app/services/corporation/corporation.service';
import { CrmTreeService } from 'src/app/services/crm-tree/crm-tree.service';
import { PersonasService } from 'src/app/services/personas/personas.service';

@Component({
  selector: 'app-crm-tree',
  templateUrl: './crm-tree.component.html',
  styleUrls: ['./crm-tree.component.scss']
})
export class CrmTreeComponent {
  @Input() parameters: any = {};
  @ViewChild('menu') menu!: MatMenu;
  @ViewChild('submenu') submenu!: MatMenu;
  @ViewChild('addTrigger') addTrigger!: MatMenuTrigger;

  crmAcronymArray = [{level: 1, label: 'JO'}, {level: 2, label: 'MP'}, {level: 3, label: 'CL'}, {level: 4, label: 'OP'}]
  private subscription: Subscription = new Subscription();

  files!: any[];
  filesOld!: any[]

  menuLevelArray: any = []

  frequencyArray: any = []

  attachments_deleted: any = []

  queueAlert: any = []
  queueTime: any = []

  openTree: boolean = false;

  hasSelectedFile = false;
  properties: any = {}

  selectedFlag: any = { lang: 'en', file: 'us.svg' };
  journeyArray: any = []

  crm_tree: any = {}
  personas: any = {}
  technologies: any = {}
  guidelineProject: any = {}

  attachmentArray: any = []
  arrayPersonas: any = []
  arrayTechnologies: any = []
  arrayGuidelineProject: any = []

  arraySumFte: any = {}
  nameBpmn: string = ''
  isShow: boolean = false;
  isShowEdit: boolean = false;
  isShowDelete: boolean = false;
  isShowImport: boolean = false;
  isChangeTree: boolean = false;
  isChangeTreeModalExit: boolean = false;
  isEdited = false;
  xlsFiles: any
  noData: boolean = false;
  nodeDropArray: any = []
  isLoading: boolean = false;
  isLoadingExport: boolean = false;
  selectedNode: any = null;
  isSelectedNode = false;
  text: string = '';

  objectModal: any = {}

  data: any
  selectedFile: any;
  formData: FormData = new FormData()

  isPaste = false;
  copyFile: any
  cloneFile: any
  cloneOrigin: any

  isLoadingClipboard = false;

  defaultColumns: any = []

  positionOptions: TooltipPosition[] = ['below'];
  position = new FormControl(this.positionOptions[0]);
  optionsArray: any = []

  extendedAttributeArray: any = []

  filterArray: any = []
  filterCursor: number = 0
  isSearch: boolean = false

  menuArray: Array<{
    name: string;
    icon: string;
    action?: (node: any, event: Event | MouseEvent) => void;
    permission?: string;
    condition: (node?: any) => boolean;
    tooltip: string;
    submenu?: Array<{
      name: string;
      action: () => void;
    }>;
    isInfo?: boolean;
  }> = [
    {
      name: 'Adicionar',
      icon: 'fa-solid fa-plus',
      action: (node, event: Event) => this.loadModal(1, node, event),
      permission: 'create_process',
      condition: (node) => this.getSystemPermission('crm_tree', 'create_process') && !this.isPaste && node?.level > 0,
      tooltip: 'businessSolution/top/info/add'
    },
    {
      name: 'Ordenar Alfabeticamente',
      icon: 'fas fa-arrow-up-z-a',
      action: (node, event: Event) => this.sortChildrenAlphabetically(node, event as MouseEvent),
      condition: (node) => node?.children && node.children?.length > 0 && this.getSystemPermission('crm_tree', 'order_process'),
      tooltip: 'businessSolution/top/info/sort_children'
    },
    {
      name: 'Excluir',
      icon: 'fas fa-trash',
      action: (node, event: Event) => this.showDeleteItemModal(node, event as MouseEvent),
      permission: 'delete_process',
      condition: (node) => this.getSystemPermission('crm_tree', 'delete_process') && 
        (!node?.children || node.children?.length == 0) && 
        !this.isPaste && (!node?.clones || node.clones?.length == 0),
      tooltip: 'businessSolution/top/info/delete_process'
    },
    {
      name: 'Copiar para Área de Transferência',
      icon: 'fas fa-clipboard',
      action: (node, event: Event) => this.copyClipboard(node, event as MouseEvent),
      permission: 'transfer_process',
      condition: (node) => this.getSystemPermission('crm_tree', 'transfer_process') && 
        !this.isPaste && !this.isEdited && !this.isLoadingClipboard,
      tooltip: 'businessSolution/top/info/copy_to_clipboard'
    },
    {
      name: 'Colar',
      icon: 'fas fa-paste',
      action: (node, event: Event) => this.pasteCopyNode(node, event as MouseEvent),
      condition: (node) => {
        const hasPermission = this.getSystemPermission('crm_tree', 'copy_process') || 
          this.getSystemPermission('crm_tree', 'clone_process');
        return this.showPaste(node) && (!node?.is_cut || node?.is_cut == false) && 
          hasPermission && this.isPaste && node?.level > 0;
      },
      tooltip: 'businessSolution/top/info/paste'
    },
    {
      name: 'Informação',
      icon: 'fa-solid fa-circle-info',
      isInfo: true,
      condition: (node) => !this.showPaste(node) && !(!node?.is_cut || node?.is_cut == true),
      tooltip: 'errors/businessTree/SameNameElement'
    },
    {
      name: 'Copiar',
      icon: 'fas fa-copy',
      action: (node, event: Event) => this.copyNode(node, event as MouseEvent),
      permission: 'copy_process',
      condition: () => this.getSystemPermission('crm_tree', 'copy_process') && !this.isPaste,
      tooltip: 'businessSolution/top/info/copy'
    },
    {
      name: 'Recortar',
      icon: 'fas fa-scissors',
      action: (node, event: Event) => this.copyNode(node, event as MouseEvent, 'cut'),
      permission: 'cut_proccess',
      condition: () => this.getSystemPermission('crm_tree', 'cut_proccess') && !this.isPaste,
      tooltip: 'businessSolution/top/info/cut'
    },
    {
      name: 'Clonar',
      icon: 'fas fa-clone',
      action: (node, event: Event) => this.cloneNode(node, event as MouseEvent),
      permission: 'clone_process',
      condition: () => this.getSystemPermission('crm_tree', 'clone_process') && !this.isPaste,
      tooltip: 'businessSolution/top/info/clone'
    }
  ];

  expandedKeys: { [key: string]: boolean } = {};

  constructor(
    private crmTreeService: CrmTreeService,
    private usersService: UsersService,
    private cdr: ChangeDetectorRef,
    private clipboardService: ClipboardService,
    public sharedData: FunctionService,
    private router: Router,
    private extendedAttribute: ExtendedAttributeService,
    private corporationService: CorporationService,
    private businessSolutionsService: BusinessSolutionsService,
    private personasService: PersonasService
  ) {}

  async ngOnInit() {
    this.properties = await localStorageToJsonAsync()
    await this.getCorporationExtendedAttribute()
    await this.getOptionsArray()
    await this.getCrmTree()
    await this.updateFiles({}, true)
    await this.getPersonasTree()
    await this.getCorporationResponsibleOrganization()

    if(localStorage.getItem('node_clipboard')){
      const node = to64DecodeSafe(localStorage.getItem('node_clipboard'))
      this.isPaste = true;
      this.copyFile = { ...node, uuid: v4() }
      delete this.copyFile.data
      this.copyFile.description.processOwner = this.properties.me
      this.copyFile.userCreated = this.properties.me.name ?? '',
      this.copyFile.userUpdated = this.properties.me.name ?? '',
      this.copyFile.created_at = this.formatDate(new Date()),
      this.copyFile.updated_at = this.formatDate(new Date())

      this.updateValueCrmTree(this.copyFile);

      localStorage.removeItem('node_clipboard')
    }      
  }

  updateValueCrmTree(node: any){
    node.crmTree = true;
    if(node.children && node.children?.length > 0){
      node.children.forEach((item: any) => {
        this.updateValueCrmTree(item);
      });
    }
  }

  eventStopPropagation(event: Event){
    event.stopPropagation()
  }

  getNameCorporation(): string{
    return this.properties?.corporation?.name || ""
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: any): void {
    if (this.isEdited) {
      event.returnValue = true;
    }
  }

  navigate(url: string){
    this.router.navigate([url])
  }

  getIconLevel(level: string): string{
    let response: string = ''
    response = this.crmAcronymArray.find((item: any) => { return item.level == level})?.label ?? '-'
    return response
  }

  onMenuOpen(node: any) {
    this.selectedNode = node;
  }

  async getCorporationExtendedAttribute() {
    try {
      const response: any = await this.extendedAttribute.getCorporationExtendedAttribute();
      if(response.data){
        // this.extendedAttributeArray = response.data
        this.extendedAttributeArray = response.data
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async getPersonasTree() {
    try {
      const response: any = await this.personasService.getPersonasTree(this.parameters).toPromise();
      if (response && response.data) {
        this.personas = parse(response.data)

        this.arrayPersonas = this.personas.json;
      } else {
        throw new Error('Erro ao consultar àrvore de personas!\nConsulte o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async initParameters(level?: number) {
    this.parameters = {}
    this.parameters.inputs = {}
    this.parameters.parent = {}
    this.parameters.isEdit = false
    this.parameters.business = this.properties.corporation.corporation_name
    this.parameters.item = {}
    this.parameters.item.attachments = []
    this.parameters.item.level = level
    this.parameters.arrayOrganograms = this.findOrganogramNodes(this.arrayPersonas)

    let uuid = v4()
    this.parameters.item.uuid = uuid
    this.parameters.item.key = uuid
    this.parameters.extendedAttributeArray = this.extendedAttributeArray
    this.parameters.crmTree = true;

    this.parameters.optionsArray = JSON.parse(JSON.stringify(this.optionsArray))

    switch (level) {
      case 4:
        this.parameters.optionsArray.tabArray = this.optionsArray?.tabArray?.filter((item: any) => { return ['addCode', 'contacts', 'phase', 'fte', 'attachments', 'extendedAttributes'].includes(item.slug) })
        break;
      case 3:
        this.parameters.optionsArray.tabArray = this.optionsArray?.tabArray?.filter((item: any) => { return ['addCode', 'contacts', 'strategicPlanning', 'attachments', 'extendedAttributes'].includes(item.slug) })
        break;
      default:
        this.parameters.optionsArray.tabArray = this.optionsArray?.tabArray?.filter((item: any) => { return ['addCode', 'attachments', 'extendedAttributes'].includes(item.slug) })
        break;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  onFileInputChange(event: Event): void {
    this.xlsFiles = event.target as HTMLInputElement;
    this.hasSelectedFile = this.xlsFiles.files && this.xlsFiles.files?.length > 0;
  }

  async getOptionsArray() {
    try {
      const response: any = await this.businessSolutionsService.getOptionsArray();
      this.objectModal.optionsArray = {}
      if (response && response.data && response.data.frequency) {
        this.defaultColumns = response.data.defaultColumns
        const array = ['addCode', 'contacts', 'strategicPlanning', 'phase', 'fte', 'attachments', 'extendedAttributes']
        this.optionsArray = response.data
        this.optionsArray.tabArray = this.optionsArray.tabArray.filter((item: any) => {
          return array.includes(item.slug) 
        })
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async getUsers(status: any = null) {
    try {
      const response: any = await this.usersService.getUsers(status, { owner: true}).toPromise();

      if (response && response.data) {
        this.optionsArray.usersArray = response.data
      } else {
        throw new Error('Erro ao consultar array de status!\nConsulte o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async getCorporationResponsibleOrganization(event?: any) {
    try {
      const response: any = await this.corporationService.getCorporationResponsibleOrganization();
      if (response && response.data) {
        let tempArray = response.data
        tempArray = tempArray.filter((item: any) => item.name && item.uuid)
          .map((item: any) => ({
            name: item.name,
            uuid: item.uuid
          }))
        this.optionsArray.organizationResponsibleArray = [...tempArray];
        if (this.getSystemPermission('crm_tree', 'create_responsible_organization')) {
          this.optionsArray.organizationResponsibleArray.unshift({ name: 'New +', uuid: '-1' })
        }
      } else {
        throw new Error('Erro ao consultar tipos de anexos!\nConsulta o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }


  async getCrmTree() {
    this.attachmentArray = this.crmTreeService.attachmentArray ?? []
    this.isLoading = true;
    this.isShowImport = false

    try {
      const response: any = await this.crmTreeService.getCrmTree(this.parameters).toPromise();

      if (response && response.data) {
        this.crm_tree = parse(response.data)
        this.files = this.crm_tree.json;
        this.filesOld = this.crm_tree.json;
        this.isShowImport = false;
        this.noData = this.files?.length == 0
        await this.collapseAll()
      } else {
        throw new Error('Erro ao consultar àrvore de negócios!\nConsulte o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.isLoading = false;
  }

  searchNodes(): void {
    this.filterCursor = 0;
    this.isSearch = true;
    this.filterArray = this.filterNodes(this.files, this.text);
    this.next();
  }

  next() {
    if (this.filterCursor < this.filterArray?.length) {
      this.filterCursor++;
      this.scrollToNode(this.filterArray[this.filterCursor - 1]);
    }
  }

  previous() {
    if (this.filterCursor > 1) {
      this.filterCursor--;
      this.scrollToNode(this.filterArray[this.filterCursor - 1]);
    }
  }

  scrollToNode(uuid: string) {
    const node = this.findNodeByUUID(this.files, uuid);
    
    if (node) {
      this.selectedFile = node;      
      this.expandParentNodes(node);
      
      // Adiciona um pequeno delay para garantir que a árvore foi atualizada
      setTimeout(() => {
        const element = document.getElementById(uuid);
        
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          // Tenta expandir todos os nós para encontrar o elemento
          this.expandAll();
          setTimeout(() => {
            const elementAfterExpand = document.getElementById(uuid);
            if (elementAfterExpand) {
              elementAfterExpand.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 100);
        }
      }, 100);
    }
  }

  expandParentNodes(node: any) {
    let parentNode = node.parent;
    
    while (parentNode) {
      parentNode.expanded = true;
      parentNode = parentNode.parent;
    }
  }

  findNodeByUUID(nodes: any[], uuid: string): any {
    for (let node of nodes) {
      
      if (node.uuid === uuid) {
        return node;
      }
      
      if (node.children && node.children?.length > 0) {
        const found = this.findNodeByUUID(node.children, uuid);
        if (found) return found;
      }
    }
      
    return null;
  }

  filterNodes(nodes: any[], query: string): string[] {
    const result: string[] = [];
    const searchText = query.toLowerCase();

    const searchNode = (node: any) => {
      if (node.label && node.label.toLowerCase().includes(searchText)) {
        result.push(node.uuid);
      }
      
      if (node.children) {
        node.children.forEach(searchNode);
      }
    };

    nodes.forEach(searchNode);
    
    return result;
  }

  verifyNoData() {
    if(this.files?.length == 0){
      this.noData = true;
      return
    }
    this.noData = false;
  }

  private filterNode(node: TreeNode, query: string, includeParents: boolean = false): boolean {
    if(!node.label){
      return false
    }
    const labelMatches = node.label.toLowerCase().includes(query.toLowerCase());

    if (labelMatches) {
      return true;
    }

    if (node.children) {
      const anyChildMatches = node.children.some((child) => this.filterNode(child, query, true));

      if (anyChildMatches) {
        return true;
      }
    }

    return false;
  }

  async flipTree(){
    this.openTree = !this.openTree;
    if(this.openTree){
      return this.expandAll()
    }
    return this.collapseAll()
  }

  async expandAll() {
    this.files?.forEach((node) => {
      this.expandRecursive(node, true);
    });
  }

  async collapseAll() {
    if(!this.files || !this.files?.length){
      return
    }
    this.files?.forEach((node) => {
      this.expandRecursive(node, false);
    });
  }

  expandRecursive(node: any, isExpand: boolean) {
    this.openTree = isExpand
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode: any) => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  async getCrmTreeNew(node?: any){
    if(Object.keys(node)?.length > 0){
      this.parameters.parent.uuid = node.uuid;
      this.parameters.parent.label = node.label;
    }
    this.parameters.item.status = 'new'
  }

  findMasterClone(uuid: string): any {
    let nodeMasterKey: any;

    const foreachTree = (node: any) => {
      if (node.uuid == uuid) {
        nodeMasterKey = node;
        return node
      }

      if (node.children && node.children?.length > 0) {
        node.children.forEach(foreachTree);
      }
    };

    this.files?.forEach(foreachTree);
    return nodeMasterKey;
  }

  async copyNode(node: any, event: Event, type?: string) {
    this.isPaste = true;
    if (event) {
      event.stopPropagation();
    }

    if (type === 'cut') {
      const markNodeAndChildrenAsCut = (nodeToMark: any) => {
        nodeToMark.is_cut = true;
        
        if (nodeToMark.children && nodeToMark.children?.length > 0) {
          nodeToMark.children.forEach((child: any) => {
            markNodeAndChildrenAsCut(child);
          });
        }
      };

      markNodeAndChildrenAsCut(node);
      this.copyFile = node;
    } else {
      const copyNodeRecursive = (nodeToCopy: any, parentLevel: number) => {
        const newNode = {
          ...nodeToCopy,
          uuid: v4(),
          key: v4(),
          level: parentLevel + 1,
          nivel: parentLevel + 1,
          parent: nodeToCopy.parent ? { ...nodeToCopy.parent } : undefined,
          children: []
        };

        if (newNode.parent) {
          delete newNode.parent.children;
        }

        delete newNode.error;
        
        // Copia os anexos mantendo o arquivo original
        if (newNode.attachments && newNode.attachments?.length > 0) {
          newNode.attachments = newNode.attachments.map((attachment: any) => {
            // Se o anexo tem um arquivo, faz uma cópia real do arquivo
            if (attachment.file) {
              const fileCopy = new File([attachment.file], attachment.file.name, {
                type: attachment.file.type,
                lastModified: attachment.file.lastModified
              });
              return {
                ...attachment,
                is_copied: true,
                file: fileCopy
              };
            }
            return attachment;
          });
        } else {
          newNode.attachments = [];
        }

        if (nodeToCopy.children && nodeToCopy.children?.length > 0) {
          newNode.children = nodeToCopy.children.map((child: any) => {
            return copyNodeRecursive(child, newNode.level);
          });
        }

        return newNode;
      };

      const copyNode = copyNodeRecursive(node, node.level);
      this.copyFile = copyNode;
    }

    if (!node.clone_by) {
      delete this.copyFile.clone_by;
    }
    delete this.copyFile.clones;
    delete this.copyFile.is_approved;
  }

  async pasteCopyNode(node: any, event: Event){
    if(event){
      event.stopPropagation()
    }

    if (!this.copyFile) {
      return;
    }

    const updateLevels = (currentNode: any, parentLevel: number, parentUuid: string) => {
      currentNode.level = parentLevel + 1;
      currentNode.nivel = parentLevel + 1;
      currentNode.master = parentUuid;
      
      // Encontra o nó pai na árvore
      const parentNode = this.findNodeByUUID(this.files, parentUuid);
      if (parentNode) {
        currentNode.parent = parentNode;
      }

      if (currentNode.children && currentNode.children?.length > 0) {
        currentNode.children.forEach((child: any) => {
          updateLevels(child, currentNode.level, currentNode.uuid);
        });
      }
    };

    // Funções auxiliares para o renomeamento
    const removeLastNumber = (label: string): string => {
      return label.replace(/\(\d+\)$/, '').trim();
    };

    const findLastNumber = (label: string): number => {
      const matches = label.match(/\((\d+)\)$/);
      if (!matches) return 0;
      return parseInt(matches[1]);
    };

    const findNextAvailableNumber = (siblings: any[], baseLabel: string): number => {
      let number = 1;
      const existingNumbers = siblings
        .map(sibling => {
          const siblingBaseLabel = removeLastNumber(sibling.label);
          if (siblingBaseLabel === baseLabel) {
            return findLastNumber(sibling.label);
          }
          return 0;
        })
        .filter(num => num > 0);

      while (existingNumbers.includes(number)) {
        number++;
      }
      return number;
    };

    // Lógica de renomeamento
    const siblings = node && node.children ? node.children : this.files;
    const originalLabel = this.copyFile.label;
    const baseLabel = removeLastNumber(originalLabel);
    
    const hasMatchingSibling = siblings.some((sibling: { label: string }) => 
      removeLastNumber(sibling.label) === baseLabel
    );

    if (hasMatchingSibling) {
      const nextNumber = findNextAvailableNumber(siblings, baseLabel);
      this.copyFile.label = `${baseLabel} (${nextNumber})`;
    } else {
      this.copyFile.label = originalLabel;
    }

    // Atualiza os níveis e o master da estrutura
    const parentUuid = node ? node.uuid : 'ROOT';
    updateLevels(this.copyFile, node ? node.level : 0, parentUuid);

    if (this.copyFile.is_cut) {
      // Remove a flag is_cut de toda a estrutura
      const removeAllCutFlags = (nodeToClean: any) => {
        nodeToClean.is_cut = false;
        
        if (nodeToClean.children && nodeToClean.children?.length > 0) {
          nodeToClean.children.forEach((child: any) => {
            removeAllCutFlags(child);
          });
        }
      };
      
      removeAllCutFlags(this.copyFile);

      // Função para remover o nó recortado da árvore
      const removeNodeFromTree = (nodes: any[], uuidToRemove: string): any[] => {
        return nodes.filter(node => {
          if (node.uuid === uuidToRemove) {
            return false;
          }
          if (node.children && node.children?.length > 0) {
            node.children = removeNodeFromTree(node.children, uuidToRemove);
          }
          return true;
        });
      };

      // Remove o nó recortado da árvore
      this.files = removeNodeFromTree(this.files, this.copyFile.uuid);
      this.filesOld = [...this.files];
    }

    // Adiciona o nó ao seu novo local
    if(node && node.children) {
      node.children.push(this.copyFile);
    } else {
      this.files.push(this.copyFile);
    }

    await this.updateFiles();
    this.finishedCopyClone();
  }

  async finishedCopyClone(){
    this.isPaste = false;
    
    this.files?.forEach((item: any) => {
      if(!item.uuid || !item.key) {
        item.uuid = v4();
        item.key = item.uuid;
      }
    });
    
    this.cdr.detectChanges();
    delete this.copyFile;
  }

  cloneNode(node: any, event: Event){
    this.isPaste = true;

    if(event){
      event.stopPropagation()
    }

    const cloneNodeRecursive = (nodeToClone: any, parentLevel: number) => {
      const newNode = {
        ...nodeToClone,
        clone_by: nodeToClone.uuid,
        uuid: v4(),
        key: v4(),
        level: parentLevel + 1,
        nivel: parentLevel + 1,
        parent: nodeToClone.parent ? { ...nodeToClone.parent } : undefined,
        children: []
      };

      if (newNode.parent) {
        delete newNode.parent.children;
      }

      delete newNode.error;
      delete newNode.attachments;
      newNode.attachments = [];

      if (nodeToClone.attachments && nodeToClone.attachments?.length > 0) {
        nodeToClone.attachments.forEach((item: any) => {
          newNode.attachments.push({ ...item, is_copied: true });
        });
      }

      if (nodeToClone.children && nodeToClone.children?.length > 0) {
        newNode.children = nodeToClone.children.map((child: any) => {
          return cloneNodeRecursive(child, newNode.level);
        });
      }

      return newNode;
    };

    const cloneNode = cloneNodeRecursive(node, node.level);
    this.copyFile = cloneNode;
  }

  findAndAddChild(cloneByKey: number, childUuid: number) {
    const traverseTree = (currentNode: any) => {
      if (currentNode.uuid === childUuid) {
        currentNode.children = currentNode.children || [];
        currentNode.children.push(childUuid);
      } else if (currentNode.children) {
        currentNode.children.forEach((child: any) => traverseTree(child));
      }
    };

    this.files?.forEach((node: any) => traverseTree(node));
  }

  async recursiveUpdateCopyChildren(obj: any, parameters?: any){
    await obj?.children?.forEach(async (nodeChild: any) => {
      if(parameters?.slug == 'initial_config'){
        delete nodeChild.parent;

        if(parameters?.type == 'cut'){
          nodeChild.is_cut = true;
        }else if(parameters?.type == 'no-cut'){
          nodeChild.is_cut = false;
        }
      }else if(parameters?.slug == 'code_and_level'){
        delete nodeChild.data;
        nodeChild.level = parameters.level + 1;
        nodeChild.nivel = parameters.level + 1;
        
        // Só gera novo UUID se NÃO for um nó que foi recortado
        if(!nodeChild.is_cut && !obj.is_cut){
          nodeChild.uuid = v4();
          nodeChild.key = nodeChild.uuid;
        } else {
        }

        nodeChild.master = obj.uuid;
      }

      if(nodeChild.children){
        await this.recursiveUpdateCopyChildren(nodeChild, { ...parameters, level: nodeChild.level});
      }
    });
  }

  async copyClipboard(node: any, event: Event){
    let copyFile: any = {}
    this.isLoadingClipboard = true;
    if(event){
      event.stopPropagation()
    }

    if (node.clone_by) {
      node = this.findMasterClone(node.clone_by)
    }

    copyFile = {}
    copyFile = {...node};
    delete copyFile.parent

    await this.recursiveUpdateCopyChildren(copyFile, { slug: 'initial_config' })

    copyFile = await JSON.parse(JSON.stringify(copyFile));

    await this.recursiveUpdateCopyChildren(copyFile, { slug: 'clipboard' })

    delete copyFile.clone_by
    delete copyFile.clones
    delete copyFile.is_approved

    try {
      const response: any = await this.clipboardService.setNodeToClipboard(copyFile)
      if ([201, 202].includes(response.status)) {
        this.copyFile = copyFile;
        // this.isPaste = true;
        addAlert('success', response.message)
      } else {
        addAlert('danger', response.message)
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.isLoadingClipboard = false;
  }

  showPaste(node?: any): boolean{
    let flag: boolean = true
    // && copyFile?.clone_by == null
    
    if(node?.children){
      if(node?.children?.length > 0){
        node.children.forEach((item: any) => {
          if(item?.label == this.copyFile?.label && this.copyFile?.clone_by != null){
            flag = false
          }
          // Verifica se o UUID já existe e se o nó está marcado como cut
          if(item?.uuid == this.copyFile?.uuid && this.copyFile?.is_cut){
            flag = false
          }
        });
      }
    }else{
      this.files.forEach((item: any) => {
        if(item?.label == this.copyFile?.label && this.copyFile?.clone_by != null){
          flag = false
        }
        if(item?.uuid == this.copyFile?.uuid && this.copyFile?.is_cut){
          flag = false
        }
      });
    }
    return flag 
  }

  async loadModal(type: number, node: any = {}, event?: Event){
    this.isShowEdit = false;
    this.isShow = false;

    if(node.node?.access_users_array?.length > 0 && !node.node?.access_users_array?.includes(this.properties?.me?.uuid) && !this.properties?.me?.is_admin_master){
      addAlert('danger', this.getLanguages('error/access_restriction'))
      return
    }
    if(type == 0 || this.isPaste){
      return
    }else if(type == 1){
      await this.showCreateItemModal(node, event)
      return
    }else if(type == 2){
      if(!this.getSystemPermission('crm_tree', 'view_process')){
        return
      }
      node = this.selectedFile
      await this.showEditItemModal(node)
      return
    }else if(type == 3){
      await this.showDeleteItemModal(node)
      return
    }
  }

  setUpdateTreeItem (uuid: string, node: any) {
    this.files?.forEach((item: any, index: number) => {
      if (uuid == item.uuid) {
        this.files[index] = node
      } else if (item.children?.length > 0) {
        this.setUpdateTreeItemRecursive(item.children, uuid, node)
      }
    })
  }

  setUpdateTreeItemRecursive (array: any, uuid: string, node: any) {
    array.forEach((item: any, index: number) => {
      if (uuid == item.uuid) {
        array[index] = node
      } else if (item.children?.length > 0) {
        this.setUpdateTreeItemRecursive(item.children, uuid, node)
      }
    })
  }

  async showCreateItemModal(node: any = {}, event?: Event) {
    if(event){
      event.stopPropagation()
    }
    this.selectedFile = node
    this.cdr.detectChanges();
    await this.initParameters(node.level + 1);

    this.parameters.isEdit = true;
    await this.getCrmTreeNew(node);

    if(Object.keys(node)?.length === 0){
      this.parameters.item.master = 'ROOT'
    }

    this.isShow = true;
    this.objectModal = { ...this.parameters }
    this.objectModal.is_new = true;
    this.objectModal.files = [ ...this.files ]
    this.objectModal.filesOld = [ ...this.filesOld ]
    this.objectModal.parentUuid = node?.uuid ?? 'ROOT'
    // if(!node.data){
    //   this.objectModal.isJourney = true
    // }

  }

  async showEditItemModal(node: any = {}, event?: Event) {
    if (!node) {
      return;
    }

    this.cdr.detectChanges();
    await this.initParameters(node.level);

    if (!node.rows || !node.rows.skills) {
      node.rows = node.rows ? {...node.rows, skills: []} : {skills: []}
    }

    this.parameters.item = { ...node }
    this.parameters.children_array = []
    delete this.parameters.item.parent

    if (this.parameters.item.children) {
      this.parameters.item.children.forEach((item: any) => {
        this.parameters.children_array.push(item.uuid);
      });
    }

    delete this.parameters.item.children
    this.parameters.item = JSON.parse(JSON.stringify(this.parameters.item));
    this.parameters.item.description = {...node.description}

    this.parameters.business = this.properties.corporation.corporation_name

    this.objectModal = { ...this.parameters }
    this.objectModal.is_new = false;
    this.objectModal.files = this.files
    this.objectModal.filesOld = this.filesOld
    this.objectModal.attachments_deleted = this.attachments_deleted
    this.isShowEdit = true;
  }

  async showDeleteItemModal(node: any = {}, event?: Event) {
    if(event){
      event.stopPropagation();
    }

    this.isShowEdit = false;
    this.isShow = false;

    this.parameters.item = { ...node }
    this.objectModal = { ...this.parameters }
    this.objectModal.files = this.files
    this.objectModal.filesOld = this.filesOld

    if(!node){
      this.openCloseModalDelete(false)
      return
    }
    this.openCloseModalDelete(true)
  }

  openCloseModalDelete (option: boolean = true) {
    this.isShowDelete = option;
  }

  async updateFiles(event?: any, ngOnInit?: any) {
    let flagIsImport = false; 

    if(!ngOnInit){
      this.isEdited = true;
      this.sharedData.isChangeTree = true
    }

    if(event){
      if (event.files) {
        this.files = event.files;
        this.filesOld = event.filesOld ?? event.files;
        if(!event.item){
          flagIsImport = true
        }
      }
      if (event.isShow) {
        this.isShow = event.isShow
      }
    }

    this.verifyNoData()

    this.noData = this.files?.length == 0

    this.journeyArray = []
    this.files?.forEach((item: any) => {
      this.recursiveUpdateSize(item, 1, flagIsImport);
      this.journeyArray.push({
        name: item.label,
        icon: item.icon,
        indicators: item.indicators,
        total_process: this.updateTotalProcess(item.children),
        personas: item.personas?.filter((persona: any) => persona.cost > 0)?.length
      })
    });

    if(event?.item){
      this.selectedFile = event.item

      this.selectedFile.fte = this.selectedFile.fte_one 
      this.selectedFile.fte_cost = this.selectedFile.fte_cost_one

      await this.findClones()
    }


    await this.recursiveUpdateValueIsClonned(this.files, 1)
    await this.recursiveUpdateValueIsClonned(this.files, 2)
  }

  async sumFte(item: any){
    // item.description.fte_cost -= item.description.fte_cost_one
    // item.description.fte -= item.description.fte_one

    // item.description.fte_cost_one = 0
    // item.description.fte_one = 0


    // item.personas?.forEach((persona: any) => {
    //   item.description.fte_cost_one += (iterateTreeAndFindNode(this.arrayPersonas, persona.uuid)  * persona.cost)
    //   item.description.fte_one += persona.cost;
    // });
    await item.personas?.forEach((persona: any) => {
      if (this.findNodeByUUID(this.arrayPersonas, persona.uuid) != null && !this.findOrganogramNodes(this.arrayPersonas).find((item: any) => item.uuid === persona.uuid)) {
        item.description.fte_cost_one += (iterateTreeAndFindNode(this.arrayPersonas, persona.uuid) * persona.cost);
        item.description.fte_one += persona.cost;
      }
    });    

    item.description.fte += item.description.fte_one
    item.description.fte_cost += item.description.fte_cost_one
  }

  async recursiveUpdateValueIsClonned(array: any, part: number){
    if(part == 1){
      await asyncForEach(array, async (node: any) => {
        node.is_cloned = false
  
        if (node.children && node.children?.length > 0) {
          await this.recursiveUpdateValueIsClonned(node.children, 1)
        }
      }) 
    }else{
      await asyncForEach(array, async (node: any) => {
        if(node.clone_by){
          if(this.findMasterClone(node.clone_by)){
            this.findMasterClone(node.clone_by).is_cloned = true
          }
        }
  
        if (node.children && node.children?.length > 0) {
          await this.recursiveUpdateValueIsClonned(node.children, 2)
        }
      })
    }
  }

  async findClones(){
    const nodeCloned = {
      attachments: this.selectedFile.attachments,
      columns: this.selectedFile.columns,
      complements: this.selectedFile.complements,
      configurations: this.selectedFile.configurations,
      description: this.selectedFile.description,
      indicators: this.selectedFile.indicators,
      integrations: this.selectedFile.integrations,
      is_approved: this.selectedFile.is_approved,
      maturity: this.selectedFile.maturity,
      personas: this.selectedFile.personas,
      technologies_table: this.selectedFile.technologies_table,
      project: this.selectedFile.project,
      skills: this.selectedFile.skills,
      rules: this.selectedFile.rules,
      contacts: this.selectedFile.contacts,
      strategicPlanning: this.selectedFile.strategicPlanning,
      phase: this.selectedFile.phase,
      fte_tab: this.selectedFile.fte_tab,
      transactions: this.selectedFile.transactions,
      extendedAttributes: this.selectedFile.extendedAttributes,
      links: this.selectedFile.links,
      label: this.selectedFile.label,
      rows: this.selectedFile.rows,
      status: this.selectedFile.status
    };
    await this.recursiveAsyncForeach(this.files, nodeCloned)

    delete this.selectedFile;
    this.cdr.detectChanges();
  }

  async recursiveAsyncForeach(array: any, nodeCloned: any) {
    await asyncForEach(array, async (node: any) => {
      if (this.selectedFile.uuid == node.clone_by) {
        Object.assign(node, nodeCloned)
      }

      if (node.children && node.children?.length > 0) {
        await this.recursiveAsyncForeach(node.children, nodeCloned)
      }
    })
  }

  updateTotalProcess(array: any[]): number {
    let total = 0;

    if (array && array?.length > 0) {
      for (let i = 0; i < array?.length; i++) {
        const item = array[i];
        total++;

        if (item.children && item.children?.length > 0) {
          total += this.updateTotalProcess(item.children);
        }
      }
    }

    return total;
  }

  formatDate(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);
  
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  recursiveUpdateSize(item: any, level: number, flagIsImport: boolean) {
    item.description = item.description ? item.description : {}
    if(flagIsImport){
      item.userCreated = item?.userCreated ? item?.userCreated : this.properties?.me?.name,
      item.userUpdated = item?.userUpdated ? item?.userUpdated : this.properties?.me?.name,
      item.created_at = item?.created_at ? item?.created_at :  this.formatDate(new Date()),
      item.updated_at = this.formatDate(new Date())
    }
  
    item.level = item.level ? item.level : level;
    item.nivel = item.level;

    if (item.children && item.children?.length > 0) {
      item.size = item.children.reduce((acc: number, child: any) => {
        return acc + this.recursiveUpdateSize(child, level + 1, flagIsImport);
      }, 0);
    } else {
      if(flagIsImport){
        item.userCreated = item?.userCreated ? item?.userCreated : this.properties?.me?.name,
        item.userUpdated = item?.userUpdated ? item?.userUpdated : this.properties?.me?.name,
        item.created_at = item?.created_at ? item?.created_at :  this.formatDate(new Date()),
        item.updated_at = this.formatDate(new Date())
      }
      item.size = 0;
    }

    return item.size + 1;
  }

  navigateOriginNode(event: any){
    this.selectedFile = this.findMasterClone(event)
    this.loadModal(2, this.selectedFile = this.findMasterClone(event))  
  }

  async getTreeXls(type: string = '') {
    this.isLoadingExport = true;
    try {
      const response: Blob = await this.crmTreeService.getTreeXls({
        environment: this.properties.environment,
        corporation: this.properties.corporation,
        json: type == 'json',
        xls: type == 'xls'
      });

      await this.crmTreeService.downloadJsonXls(response, `${this.properties?.corporation?.slug}-crm-tree`, type)
      addAlert('success', this.getLanguages('businessSolution/top/info/export/success'))

    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.isLoadingExport = false;
  }

  async toggleUpload() {
    this.isShowImport = !this.isShowImport;
    this.text = ''

    if(!this.isShowImport && this.filesOld !== this.files){
      this.files = this.filesOld
    }
  }

  getSystemPermission(screen: string, action?: string){
    return systemPermissionsNew(screen, action)
  }

  isFirstColumn(node: any): boolean {
    if(node.master == 'ROOT' || !node.master){
      return true
    }
    return false
  }

  getClass(node: any): string{
    switch (this.getParentCount(node)) {
      case 1: return 'fas fa-folder-tree';
      case 2: return 'fas fa-folder';
      case 3: return 'fas fa-square';
      case 4: return 'fas fa-diagram-project';
      default: return 'fas fa-file'
    }
  }

  getParentCount(node: any): number {
    let parentCount = 0;
    let parentNode = node;

    while (parentNode && parentNode.parent) {
      parentCount++;
      parentNode = parentNode.parent;
    }
    return parentCount + 1;
  }

  async validateAllEntitys(children: any): Promise<string>{
    let Error = ''
    for(const child of children){
      delete child.error
      const siblings = children.filter((sibling: any) => sibling.label === child.label && sibling.uuid !== child.uuid)
      if(siblings?.length > 0){
        child.error = 'SameNameElement'
        this.cdr.detectChanges()
        Error = 'SameNameElement'
      }

      if(child.children && child.children?.length > 0){
        await this.validateAllEntitys(child.children)
      }
    }
    return Error
  }

   // função de apagar os objetos parent
   removeParentReferences(node: any) {
    if (node && typeof node === 'object') {
      delete node.parent;
      if (Array.isArray(node.children)) {
        node.children.forEach((child: any) => this.removeParentReferences(child));
      }
    }
  }

  async saveTree(version: any = null, uuid: any = null){
    const getNextCodeSuffix = (siblings: any[]) => {
      const usedSuffixes = siblings
        .map(child => {
          const codeParts = (child.data || '').split('.');
          const last = codeParts[codeParts.length - 1];
          return parseInt(last, 10);
        })
        .filter(num => !isNaN(num));
      let next = 5;
      while (usedSuffixes.includes(next)) {
        next += 5;
      }
      return next.toString().padStart(2, '0');
    };

    const updateAllCodes = (nodes: any[], parentCode: string = '') => {
      nodes.sort((a, b) => a.label.localeCompare(b.label, 'pt-BR', {numeric: true}));
      nodes.forEach((node, idx) => {
        const nextSuffix = ((idx + 1) * 5).toString().padStart(2, '0');
        node.data = parentCode ? `${parentCode}.${nextSuffix}` : nextSuffix;
        if (node.children && node.children.length > 0) {
          updateAllCodes(node.children, node.data);
        }
      });
    };

    updateAllCodes(this.files);

    const Error = await this.validateAllEntitys(this.files)
    if(Error == 'SameNameElement'){
      addAlert('orange', this.getLanguages('errors/businessTree/SameNameElement'))
      return
    }
    await this.setFormData(version)
    this.isLoading = true;
    this.isShow = false;
    this.isShowEdit = false;
    this.clearFilter()
    delete this.selectedFile

    try {
      const response: any = await this.crmTreeService.setCrmTree(this.formData, uuid)
      if ([201, 202].includes(response.status)) {
        addAlert('success', response.message)
        this.attachments_deleted = []

        await this.getCrmTree()

        this.isLoading = false;
        this.isEdited = false;
        this.sharedData.isChangeTree = false

        if(localStorage.getItem('flagIndicator') && localStorage.getItem('flagIndicator') != ''){
          this.sharedData.triggerDashboardReload();
        }
        if(this.isChangeTreeModalExit){
          this.router.navigate([this.sharedData.route])
          this.isChangeTreeModalExit = false;
        }
      } else{
        addAlert('danger', response.message)
        this.isLoading = false;
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
      this.isLoading = false;
    }
  }

  async setFormData(version?: any) {
    this.formData = new FormData()
    if(version){
      this.formData.append('name', version.name)
      if(version.reason){
        this.formData.append('reason', version.reason)
      }
    }
    // Remover todos os campos parent antes de salvar
    if (Array.isArray(this.filesOld)) {
      this.filesOld.forEach(item => this.removeParentReferences(item));
    }
    this.formData.append('json', stringify(this.filesOld))
    this.formData.append('attachments_deleted', stringify(this.attachments_deleted))
    await asyncForEach(this.attachmentArray, async (item: any) => {
      if (item.file) this.formData.append('files', item.file)
    })
  }

  getCircleClass(node: any){
    switch (node.status) {
      case 'new': return 'circle-new';
      case 'progress': return 'circle-progress';
      case 'test': return 'circle-test';
      case 'homologation': return 'circle-homologation';
      case 'finished': return 'circle-concluded';
      case 'canceled': return 'circle-canceled';
      case 'paralyzed': return 'circle-paralyzed';
      case 'lost': return 'circle-lost';
      default: node.status = 'new'; return 'circle-new'
    }
  }

  isResponsive(): boolean {
    return window.innerWidth >= 900;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {}

  getNodeIntegrations(node: any){
    node.integrations = node.integrations ?? []

    const inputs = node.integrations.filter((integration: any) => integration.type === 'input');
    const outputs = node.integrations.filter((integration: any) => integration.type === 'output');

    let aux = [...inputs, ...outputs];

    aux  = aux.map((integration: any) => {
      if (integration.type === 'input') {
        return { ...integration, type: 'in' };
      } else if (integration.type === 'output') {
        return { ...integration, type: 'out' };
      } else {
        return integration;
      }
    });

    return aux;
  }

  getToggle(op: any, integrations: any, $event: Event){
    if(!integrations || integrations?.length == 0){
      return
    }else{

    }

    op.toggle($event)
  }

  getNameFrequency(slug: string){
    let text = ''
    this.frequencyArray.forEach((frequency: any) => {
      if(frequency.slug == slug){
        text = frequency.name[to64decode(localStorage.getItem('language')).lang]
      }
    });
    return text
  }

  async toggleChangeTree(){
    this.isChangeTree = false
    this.sharedData.isShowModalChangeTree = false
    this.sharedData.isChangeTree = false
    if(!this.sharedData.isShowModalChangeTree && this.sharedData.route != ''){
      await this.router.navigate([this.sharedData.route]);
      localStorage.removeItem('flagIndicator')
      this.sharedData.route = ''
    }
  }

  onNodeExpand(event: any) {
    if (!event.node.parent) {
      this.files?.forEach((node: any) => {
        if (node.uuid != event.node.uuid) {
          node.expanded = false;
          if (node.children) {
            node.children.forEach((child: any) => {
              child.expanded = false;
            });
        }
    }
      });
    }
    
    event.node.expanded = true;
    this.cdr.detectChanges();
  }

  closeModalChange(){
    this.sharedData.isShowModalChangeTree = false
    this.isChangeTreeModalExit = true
  }

  hasError(uuid: string): boolean{
    if(!this.sharedData.arrayDuplicateName || this.sharedData.arrayDuplicateName?.length == 0){
      return false
    }

    return this.sharedData.arrayDuplicateName.includes(uuid)
  }

  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;

  getModifiedNode(node: any, level: number) {
    return { ...node, level: level };
  }

  findOrganogramNodes(nodes: any[], result: any[] = []): any[] {
    for (const node of nodes) {

      if (node.data.type === 'organogram') {
        result.push({label: node.label, uuid: node.uuid});
      }
  
      if (node.children && node.children?.length > 0) {
        this.findOrganogramNodes(node.children, result);
      }
    }
  
    return result;
  }

  clearFilter(){
    this.isSearch = false; 
    this.filterArray = [];
    this.text = ''
  }

  parametersAccessUser: any;
  isShowAccessRestrictionModal: boolean = false;

  activateAccessRestriction(node: any, event: Event){
    this.isShowAccessRestrictionModal = true
    event.stopPropagation()
    this.selectedNode = node

    let usersArray = this.optionsArray.usersArray.map((user: any) => ({
      uuid: user.uuid,
      name: user.name
    }));

    this.parametersAccessUser = { node, usersArray: usersArray }
  }

  setArrayAccessUsers(event: any){    
    const node = this.findNodeByUUID(this.files, event.node.uuid);
    if (node) {
      node.access_users_array = event.node.access_users_array;

      if(event.isCascade){
        this.applyCascade(node);
      }

      this.isEdited = true;
    }
  }

  applyCascade(node: any){
    if(node.children && node.children?.length > 0){
      node.children.forEach((child: any) => {
        child.access_users_array = node.access_users_array;
        this.applyCascade(child);
      });
    }
  }

  handleMenuItemClick(item: any, event: Event) {
    item.action(this.selectedNode, event);
   
    if (this.menu) {
      this.menu.closed.emit();
    }
  }

  async sortChildrenAlphabetically(node: any, event: Event) {
    if (event) {
      event.stopPropagation();
    }

    if (node.children) {
      // Ordena os filhos alfabeticamente
      node.children.sort((a: any, b: any) => a.label.localeCompare(b.label));
      
      // Atualiza os valores de data dos filhos
      const parentData = node.data || '0';
      const step = 5; // Incremento para cada filho
      
      node.children.forEach((child: any, index: number) => {
        const childNumber = (index + 1) * step;
        const formattedNumber = childNumber.toString().padStart(2, '0');
        child.data = `${parentData}.${formattedNumber}`;
        
        // Se o filho tiver filhos, atualiza recursivamente
        if (child.children && child.children?.length > 0) {
          this.updateChildrenData(child);
        }
      });
      
      this.isEdited = true;
      this.cdr.detectChanges();
    }
  }

  private updateChildrenData(node: any) {
    if (node.children) {
      const parentData = node.data;
      const step = 5;
      
      node.children.forEach((child: any, index: number) => {
        const childNumber = (index + 1) * step;
        const formattedNumber = childNumber.toString().padStart(2, '0');
        child.data = `${parentData}.${formattedNumber}`;
        
        if (child.children && child.children?.length > 0) {
          this.updateChildrenData(child);
        }
      });
    }
  }

}

function removeCutNodes(node: any): any | null {
  if (node.is_cut === true) {
    return null;
  }

  if (node.children) {
    node.children = node.children
      .map(removeCutNodes)
      .filter((child: any): child is any => child !== null);
  }

  return node;
}


function iterateTreeAndFindNode(tree: any[], uuidToFind: string): number{
  for (const node of tree) {
    if (node.uuid === uuidToFind) {
      if(!node.data?.cost_max || node.data?.cost_max == 0){
        return node.data.cost_min;
      }
      return (node.data.cost_min + node.data.cost_max)/2;
    }

    if (node.children && node.children?.length > 0) {
      const foundNode = iterateTreeAndFindNode(node.children, uuidToFind);
      if (foundNode) {
        return foundNode;
      }
    }
  }

  return 0;
}

